import React from 'react';
import dayjs from '@shared/lib/dayjs';
import { User } from '@/components/atoms/AppIcon';

interface VisitPatientHeaderProps {
  patientName: string | null;
  /** True when the patient's 同意書 is approaching/past expiry. */
  consentAlert: boolean;
  /** YYYY-MM-DD; rendered as MM/DD next to the name when consentAlert is on. */
  consentTermTo: string | null;
}

/**
 * Patient name row with the 同意書期限：MM/DD red badge (mirrors VisitCard).
 * Rendered alongside the patient avatar so the alert sits inline.
 */
const VisitPatientHeader: React.FC<VisitPatientHeaderProps> = ({
  patientName,
  consentAlert,
  consentTermTo,
}) => (
  <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-base text-gray-900">
    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blue-100 text-lg text-blue-600">
      <User />
    </span>
    <span className="font-semibold">{patientName ?? '—'}</span>
    <span className="text-sm text-gray-500">様</span>
    {consentAlert && consentTermTo && (
      <span className="text-sm font-medium text-red-600">
        同意書期限：{dayjs(consentTermTo).format('MM/DD')}
      </span>
    )}
  </div>
);

export default VisitPatientHeader;
